import { BnMakeAPaymentDetailsComponent } from '../bn-make-a-payment-details/bn-make-a-payment-details.component';
import { BnNoticeComponent } from '../bn-notice/bn-notice.component';
import { BnSuccessNoticeComponent } from '../bn-notice/bn-success-notice/bn-success-notice.component';
import { BnTabHeaderComponent } from '../bn-tab-header/bn-tab-header.component';
import { BillingDetailsHeaderComponent } from '../billing-details-header/billing-details-header.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { BillingPolicy } from '../add-billing/add-billing.component';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BillingNewService } from '@services/common/billing-new.service';
import { ActivatedRoute, NavigationEnd, Params, Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { Location } from '@angular/common';
import { NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BillingAssistanceCardsComponent } from '../billing-assistance-cards/billing-assistance-cards.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, BillingDetailsHeaderComponent, BnTabHeaderComponent, BnSuccessNoticeComponent, BnNoticeComponent, BnMakeAPaymentDetailsComponent, BillingAssistanceCardsComponent],
  selector: 'app-bn-make-a-payment',
  templateUrl: './bn-make-a-payment.component.html',
  styleUrls: ['./bn-make-a-payment.component.scss']
})
export class BnMakeAPaymentComponent implements OnInit, OnDestroy {

  isAcmic: boolean;
  billingPolicyData: BillingPolicy;
  policyNumber: string;
  policy: any;
  company: string;
  policies: any;
  activeClass: string;
  isOneIncPayment: boolean;

  hideAlert = false
  paymentDate = '';
  showManageWallet: boolean;
  showPayByText: boolean;
  isThereAnyActiveGWPolicy: boolean;
  destroy$ = new Subject<void>();

  constructor(
    private acmicService: AcmicService,
    private billingNewService: BillingNewService,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private router: Router,
    private location: Location,
    private navService: NavigationService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }
  onPolicySelect(val) {
    this.policyNumber = val.split(" ")[2];
    this.router.navigate(['/billing-new', this.policyNumber, 'make-a-payment']);
    this.policy = this.getPolicyOnPolicySelect(this.billingPolicyData?.policyData ?? []);
    this.company = this.billingNewService.getCompany(this.policy ? [this.policy] : []);
  }
  getPolicyOnPolicySelect(policyData) {
    const policy = policyData.find(pol => pol?.policynumber?.policyNumber === this.policyNumber)
    return policy;
  }
  getDisplayName(policyData) {
    const policy = policyData.find(pol => pol?.policynumber?.policyNumber === this.policyNumber)
    return policy?.name;
  }
  setTheBillingDataOnReload(policies) {
    const billingPolicyData: BillingPolicy = {
      title: '',
      policyNumber: this.policyNumber,
      displayName: '',
      policyData: []
    }
    if (this.policy?.policyStatus === 'ACTIVE' || this.policy?.policyStatus === 'FUTURE') {
      billingPolicyData.title = this.billingNewService.getActiveInActivePoliciesMap(policies, false).activePolicies.length === 1 ? 'Active policy' : 'Active policies';
      billingPolicyData.policyData = this.billingNewService.getActiveInActivePoliciesMap(policies, false).activePolicyMap;

    } else {
      billingPolicyData.title = this.billingNewService.getActiveInActivePoliciesMap(policies, false).inActivePolicies.length === 1 ? 'Inactive policy' : 'Inactive policies';
      billingPolicyData.policyData = this.billingNewService.getActiveInActivePoliciesMap(policies, false).inActivePolicyMap;
    }
    billingPolicyData.displayName = this.getDisplayName(billingPolicyData.policyData);
    this.billingPolicyData = billingPolicyData;
  }
  getPolicyData() {
    this.policy = this.policies?.find(pol => pol?.policynumber?.policyNumber === this.policyNumber);
    this.company = this.billingNewService.getCompany([this.policy]);
    this.setTheBillingDataOnReload(this.policies);
  }
  getPolicies() {
    this.policyDataService.$policyDetails.subscribe((policyList) => {
      if (policyList) {
        this.policies = policyList;
        this.getPolicyData();
      }
    })
  }
  getPolicyNumberFromParam() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyNumber = params['policyid'];
    })
  }
  navigateBack() {
    this.location.back();
  }
  ngOnInit(): void {
    this.billingNewService.hideBanner$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.hideAlert = res;
    });

    if (history?.state?.billingPOlicyData) {
      this.billingPolicyData = history?.state?.billingPOlicyData;
      this.policyNumber = this.billingPolicyData?.policyNumber;
    } else {
      this.getPolicyNumberFromParam();
    }
    this.getPolicies();
    this.navService.saveCurrentAction(ActionType.MakePayment);
    this.billingNewService.getOneIncPaymentStatus().subscribe((val) => {
      this.isOneIncPayment = val;
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/billing-new')) {
          if (event.url.endsWith('/make-a-payment')) {
            this.activeClass = 'active';
          }
        }
      }
    });
    this.getPolicy();
  }

  getPolicy(){
   this.policyDataService.$rawPolicies.pipe(takeUntil(this.destroy$)).subscribe(
    res=>{
      if(res){
        this.isThereAnyActiveGWPolicy = this.isActiveGwPolicyExist(res);
      }
    });
  }

  onClose(){
    this.hideAlert = true;
    this.billingNewService.setBannerState(true);
  }

  isActiveGwPolicyExist(maGWPolicy) {
    if (Array.isArray(maGWPolicy)) {
      return maGWPolicy.some(policy => (policy.policynumber?.policyNumber?.length === 10 && policy?.policyStatus === 'ACTIVE'));
    }
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}